import { Phone, MessageCircle, CalendarDays, Home, Sparkles, MapPin, Mail } from "lucide-react";
import { BRAND } from "@/data/content";
import { useBooking } from "@/lib/booking";
import { scrollToId } from "@/lib/scroll";

export function FloatingActions() {
  const { openBooking } = useBooking();
  return (
    <>
      <div data-testid="floating-actions" className="hidden md:flex fixed bottom-8 right-8 z-40 flex-col items-end gap-3">
        <a
          data-testid="floating-whatsapp"
          href={BRAND.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-grand transition-all duration-300 hover:-translate-y-1"
        >
          <MessageCircle className="h-5 w-5" />
        </a>
        <a
          data-testid="floating-call"
          href={BRAND.phoneLink}
          aria-label="Call the clinic"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-pine text-ivory shadow-grand transition-all duration-300 hover:-translate-y-1"
        >
          <Phone className="h-5 w-5" />
        </a>
        <button
          data-testid="floating-book"
          onClick={() => openBooking()}
          className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-bold text-pine-deep shadow-grand transition-all duration-300 hover:-translate-y-1 hover:bg-gold-soft"
        >
          <CalendarDays className="h-4 w-4" /> Book Appointment
        </button>
      </div>

      <nav data-testid="mobile-bottom-nav" className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-pine/10 bg-white/90 backdrop-blur-xl">
        <div className="grid grid-cols-[1fr_1fr_auto_1fr_1fr] items-end px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
          <MobileNavItem icon={Home} label="Home" onClick={() => scrollToId("home")} testid="mnav-home" />
          <MobileNavItem icon={Sparkles} label="Services" onClick={() => scrollToId("dental")} testid="mnav-services" />
          <div className="flex justify-center">
            <button
              data-testid="mnav-book"
              onClick={() => openBooking()}
              className="-mt-8 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-gold px-5 py-3.5 text-xs font-bold text-pine-deep shadow-grand ring-4 ring-white transition-transform duration-300 active:scale-95"
              aria-label="Book appointment"
            >
              <CalendarDays className="h-4 w-4" /> Book Appointment
            </button>
          </div>
          <MobileNavItem icon={MapPin} label="Clinics" onClick={() => scrollToId("clinics")} testid="mnav-clinics" />
          <MobileNavItem icon={Mail} label="Contact" onClick={() => scrollToId("contact")} testid="mnav-contact" />
        </div>
      </nav>
    </>
  );
}

function MobileNavItem({ icon: Icon, label, onClick, testid }) {
  return (
    <button data-testid={testid} onClick={onClick} className="flex flex-col items-center gap-1 py-1.5 text-pine/70">
      <Icon className="h-5 w-5" />
      <span className="text-[10px] font-bold">{label}</span>
    </button>
  );
}
